/**
 * @version 1.0.1
 * @author wuwg  <wuwg@thunisoft.com>
 * @createTime:2019-08-13,
 * @updateTime:2019-08-13
 * @copyright thunisoft fd
 * @description  *  [jsDoc中文文档]{@link  http://www.dba.cn/book/jsdoc/JSDOCKuaiBiaoQianBLOCKTAGS/CONSTRUCTS.html}
 *  [jsdoc-vuejs]{@link  http://npm.taobao.org/package/jsdoc-vuejs}  -
 *  [个人博客]{@link  http://www.wuweigang.com}
 */
export default {
    name: 'ywsf',
    data() {
        return {
            crumbsList:Object.freeze([{
                name:'域外法治',
                key:'ywsf'
            }]),
            data: {
                // 域外法治动态
                ywfzdt: {
                    image: '/static/image/ejym/ywsf/img-ywfzdt.png',
                    data: []
                },
                ywfl: {
                    image: '/static/image/ejym/ywsf/img-ywfl.png',
                    data: []
                },
                ywzc: {
                    image: '/static/image/ejym/ywsf/img-ywzc.png',
                    data: []
                },
                ywpj: {
                    image: '/static/image/ejym/ywsf/img-ywpj.png',
                    data: []
                }
            }
        };
    },
    created() {
        this.initdata();
    },
    methods: {
        // 查看更多
        handleMore(type) {
            this.$router.push({
                path: '/ywsf/more',
                query: {tab: type}
            });
        },
        // 查看详情
        handleDetail(item) {
            const url = this.$router.resolve({path: '/lltt/dedail', query: {active:'ywsf', bh: item.bh, ejlb: item.ejlb}});
            window.open(url.href, '_blank');
            window.console.log('查看详情', item);
        },
        initdata() {
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.Hsal.hsalindex.replace('{id}', '4')
            }).then((res) => {
                this.data.ywfl.data = res.data.ywfl;
                this.data.ywzc.data = res.data.ywzc;
                this.data.ywpj.data = res.data.ywpj;
            })
                .catch(() => {
                    Artery.notice.warning({
                        title: '失败',
                        desc: '查询列表失败！',
                        duration: 1
                    });
                });
        }
    }
};

